export default function httpRequestInterceptor() {
    return {
        request: function (config) {
            if (config.url.indexOf("http://") >= 0) {
                if (config.url.indexOf("?") >= 0) {
                    config.url = config.url + "&$t=" + moment(new Date()).format("x");
                }
                else {
                    config.url = config.url + "?$t=" + moment(new Date()).format("x");
                }
            }
            return config;
        }
    };
}



// WEBPACK FOOTER //
// ./src/ui/app/interceptors/httpRequestInterceptor.js